import {
  Component,
  AfterViewInit,
  TemplateRef,
  ViewChild,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { JobOpenTableComponent } from './job-open-table.component';
import { JobTableComponent } from './job-table.component';
import { HeaderBarComponent } from '@nimmsta/ng-commons-lib/header-bar';
import {
  TabsConfiguration,
  ReusableTabsComponent,
} from '@nimmsta/ng-commons-lib/reusable-tabs';

_('job.title');

type Tab = {
  title: string;
  name: string;
  filter?: string[];
  updatedTranslation: string;
  showExport: boolean;
  template?: TemplateRef<unknown>;
};
@Component({
  templateUrl: 'job.component.html',
  selector: 'app-job',
  imports: [
    HeaderBarComponent,
    ReusableTabsComponent,
    JobOpenTableComponent,
    JobTableComponent,
  ],
})
export class JobComponent implements AfterViewInit {
  @ViewChild('openJobTemplate', { static: true }) openJobTemplate!: TemplateRef<unknown>;
  @ViewChild('progressJobTemplate', { static: true }) progressJobTemplate!: TemplateRef<unknown>;
  @ViewChild('completeJobTemplate', { static: true }) completeJobTemplate!: TemplateRef<unknown>;
  @ViewChild('cancelledJobTemplate', { static: true }) cancelledJobTemplate!: TemplateRef<unknown>;
  @ViewChild('deletedJobTemplate', { static: true }) deletedJobTemplate!: TemplateRef<unknown>;
  @ViewChild('allJobTemplate', { static: true }) allJobTemplate!: TemplateRef<unknown>;

  private cdr = inject(ChangeDetectorRef);

  tabs: Tab[] = [
    {
      title: 'OPEN',
      name: 'open-jobs',
      updatedTranslation: 'job.lastUpdatedAt',
      showExport: false,
    },
    {
      title: 'IN_PROGRESS',
      name: 'progress-jobs',
      filter: ['status:IN_PROGRESS-and'],
      updatedTranslation: 'job.lastUpdatedAt',
      showExport: false,
    },
    {
      title: 'COMPLETE',
      name: 'done-jobs',
      filter: ['status:COMPLETE-and'],
      updatedTranslation: 'job.completed-updated',
      showExport: true,
    },
    {
      title: 'CANCELLED',
      name: 'cancelled-jobs',
      filter: ['status:CANCELLED-and'],
      updatedTranslation: 'job.cancelled-updated',
      showExport: true,
    },
    {
      title: 'DELETED',
      name: 'deleted-jobs',
      filter: ['status:DELETED-and'],
      updatedTranslation: 'job.deleted-updated',
      showExport: true,
    },
    {
      title: 'ALL',
      name: 'all-jobs',
      filter: [],
      updatedTranslation: 'job.lastUpdatedAt',
      showExport: true,
    },
  ];

  tabsConfig: TabsConfiguration = {
    tabs: [],
    defaultTab: 'open-jobs',
    storageKey: 'lastTabJob',
    enableRouting: true,
  };

  ngAfterViewInit(): void {
    this.tabsConfig = {
      ...this.tabsConfig,
      tabs: [
        {
          id: this.tabs[0].name,
          labelKey: this.tabs[0].title,
          template: this.openJobTemplate,
        },
        {
          id: this.tabs[1].name,
          labelKey: this.tabs[1].title,
          template: this.progressJobTemplate,
        },
        {
          id: this.tabs[2].name,
          labelKey: this.tabs[2].title,
          template: this.completeJobTemplate,
        },
        {
          id: this.tabs[3].name,
          labelKey: this.tabs[3].title,
          template: this.cancelledJobTemplate,
        },
        {
          id: this.tabs[4].name,
          labelKey: this.tabs[4].title,
          template: this.deletedJobTemplate,
        },
        {
          id: this.tabs[5].name,
          labelKey: this.tabs[5].title,
          template: this.allJobTemplate,
        },
      ],
    };
    this.cdr.detectChanges();
  }
}
